import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LanguagesService } from "src/app/services/languages.service";
import { RegistrationService } from "src/app/services/registration.service";
declare var $: any;

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FooterComponent implements OnInit {
  @Input() inputValue: string;
  @Output() sendMsgEv = new EventEmitter();
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @Output() inputValueChange = new EventEmitter();
  @Output() fileUploadEv = new EventEmitter();
  subscription: Subscription = new Subscription();
  showEmoj = true;
  lang = "";
  chatbot_lang = "";
  send_btn = false;
  //! to track the first sent message (to be a phone number):
  sentMessagesCounter = 0;

  constructor(
    private registrationService: RegistrationService,
    private language: LanguagesService
  ) {}

  ngOnInit() {
    this.subscription = this.language.get_language().subscribe((message) => {
      if (message.content) {
        this.chatbot_lang = message.content;
      } else if (localStorage.getItem("chatbot_lang")) {
        this.chatbot_lang = localStorage.getItem("chatbot_lang");
      } else {
        this.chatbot_lang = "en";
      }
    });
    // this.lang = localStorage.getItem("chatbot_lang");
    // this.chatbot_lang = localStorage.getItem("chatbot_lang")
  }

  change(newValue) {
    this.send_btn = true;
    this.inputValue = newValue;
    this.inputValueChange.emit(newValue);
  }

  sendMessage() {
    this.registrationService.registrationForm.dateOfBirth = this.inputValue;
    this.send_btn = false;
    this.sendMsgEv.emit(true);
    this.inputRef.nativeElement.value = null;
  }
  importFile(event) {
    this.fileUploadEv.emit(event);
  }
  addEmoji(event) {
    if (!this.inputValue) {
      this.inputValue = "";
    }

    this.inputValue = this.inputValue + event.emoji.native;
    $("#text").val($("#text").val() + event.emoji.native);
    this.inputValueChange.emit(this.inputValue);
    this.showEmoj = !this.showEmoj;

    console.log(event);
    console.log(this.inputValue);
  }

  switchEmoj() {
    this.showEmoj = !this.showEmoj;
    console.log("enter");
    if (this.showEmoj == true) {
      $(".float-icon").css("z-index", "99");
    } else {
      console.log("open it ");
      $(".float-icon").css("z-index", "0");
    }
  }
}
